var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security_Compliance",
    "data-name": "Security Compliance",
    transform: "translate(12 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "clock-rotate-left-solid",
    d: "M2.891,2.891,1.581,1.581A.926.926,0,0,0,0,2.232V6.477A.923.923,0,0,0,.925,7.4H5.17a.926.926,0,0,0,.655-1.581L4.638,4.634a7.4,7.4,0,1,1,1,11.312A1.235,1.235,0,0,0,4.225,17.97,9.872,9.872,0,1,0,2.891,2.891ZM9.87,4.935a.923.923,0,0,0-.925.925V9.87a.925.925,0,0,0,.27.655L11.99,13.3A.924.924,0,0,0,13.3,11.994L10.791,9.488V5.86a.923.923,0,0,0-.925-.925Z",
    fill: "#8b8b8b"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/History.fd32c0ae0938e1391ef5ffe472c062ad.svg";